import Vue from 'vue'
import Vuex from 'vuex'
import navBar from "./navBar";
import tabsValue from "./tabsValue"
import loginUser from "./loginUser";
Vue.use(Vuex)



export default new Vuex.Store({
  // state: {
  //   nav: []
  // },
  // getters: {
  //   navData: state => state.nav
  // },
  mutations: {
    resetAll(state, data) {//设置导航信息
      state.nav = data;
    }
  },
  actions: {// 管理mutations
    RESET_ALL({commit}, data) {//重置所有数据
      //清除session
      window.sessionStorage.clear();
      window.localStorage.clear();
      //重置用户
      commit('resetLoginUser', data);
      //重置tabs标签
      commit('resetTabsValue', data);
      //重置菜单
      commit('resetNav', []);
    }
  },
  modules: {
    navBar,
    tabsValue,
    loginUser
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js